webpackJsonp([100945961233241],{

/***/ "./src/components/VideoWorkaround.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function objectToStyle(obj) {
	  return Object.entries(obj).reduce(function (styleString, entry) {
	    return styleString + entry[0] + ':' + entry[1] + ';';
	  }, '');
	}
	
	var VideoWorkaround = function VideoWorkaround(_ref) {
	  var src = _ref.src,
	      style = _ref.style;
	  return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '\n    <video\n      style=' + objectToStyle(style) + '\n      muted\n      autoplay\n      playsinline\n      src="' + src + '"\n    />\n  ' }
	  });
	};
	
	exports.default = VideoWorkaround;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/copilot-card-sort.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-card-sort.931354da.jpg";

/***/ }),

/***/ "./src/pages/copilot-mobile-explorations-2.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-mobile-explorations-2.75111151.jpg";

/***/ }),

/***/ "./src/pages/copilot-mobile-fnl-1.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-mobile-fnl-1.4f6734a5.jpg";

/***/ }),

/***/ "./src/pages/copilot-sketch-focus2.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-sketch-focus2.ac582794.jpg";

/***/ }),

/***/ "./src/pages/copilot-sketch-interview2.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-sketch-interview2.380d0639.jpg";

/***/ }),

/***/ "./src/pages/copilot-video-mockup.mp4":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-video-mockup.82cd1cda.mp4";

/***/ }),

/***/ "./src/pages/copilot-web-macbook.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-web-macbook.e6a7c44a.png";

/***/ }),

/***/ "./src/pages/copilot-web-wireframe.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/copilot-web-wireframe.4215a5be.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/copilot.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Box = __webpack_require__("./src/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _List = __webpack_require__("./src/components/List.js");
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ProjectDetail = __webpack_require__("./src/components/ProjectDetail.js");
	
	var _ProjectDetail2 = _interopRequireDefault(_ProjectDetail);
	
	var _Grid = __webpack_require__("./src/components/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridItem = __webpack_require__("./src/components/GridItem.js");
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _VideoWorkaround = __webpack_require__("./src/components/VideoWorkaround.js");
	
	var _VideoWorkaround2 = _interopRequireDefault(_VideoWorkaround);
	
	var _vars = __webpack_require__("./src/styles/vars.json");
	
	var _copilotModule = __webpack_require__("./src/pages/copilot.module.styl");
	
	var _copilotModule2 = _interopRequireDefault(_copilotModule);
	
	var _copilotSketchFocus = __webpack_require__("./src/pages/copilot-sketch-focus2.jpg");
	
	var _copilotSketchFocus2 = _interopRequireDefault(_copilotSketchFocus);
	
	var _copilotSketchInterview = __webpack_require__("./src/pages/copilot-sketch-interview2.jpg");
	
	var _copilotSketchInterview2 = _interopRequireDefault(_copilotSketchInterview);
	
	var _copilotCardSort = __webpack_require__("./src/pages/copilot-card-sort.jpg");
	
	var _copilotCardSort2 = _interopRequireDefault(_copilotCardSort);
	
	var _copilotWebWireframe = __webpack_require__("./src/pages/copilot-web-wireframe.jpg");
	
	var _copilotWebWireframe2 = _interopRequireDefault(_copilotWebWireframe);
	
	var _copilotWebMacbook = __webpack_require__("./src/pages/copilot-web-macbook.png");
	
	var _copilotWebMacbook2 = _interopRequireDefault(_copilotWebMacbook);
	
	var _copilotMobileExplorations = __webpack_require__("./src/pages/copilot-mobile-explorations-2.jpg");
	
	var _copilotMobileExplorations2 = _interopRequireDefault(_copilotMobileExplorations);
	
	var _copilotVideoMockup = __webpack_require__("./src/pages/copilot-video-mockup.mp4");
	
	var _copilotVideoMockup2 = _interopRequireDefault(_copilotVideoMockup);
	
	var _copilotMobileFnl = __webpack_require__("./src/pages/copilot-mobile-fnl-1.jpg");
	
	var _copilotMobileFnl2 = _interopRequireDefault(_copilotMobileFnl);
	
	var _mobileFinal3Up = __webpack_require__("./src/pages/mobile-final-3-up-3.jpg");
	
	var _mobileFinal3Up2 = _interopRequireDefault(_mobileFinal3Up);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Copilot = function (_React$Component) {
	  _inherits(Copilot, _React$Component);
	
	  function Copilot() {
	    _classCallCheck(this, Copilot);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Copilot.prototype.render = function render() {
	    return _react2.default.createElement(
	      _ProjectDetail2.default,
	      { projectName: "copilot" },
	      _react2.default.createElement(
	        "div",
	        { ref: "content" },
	        _react2.default.createElement(
	          _Section2.default,
	          { reverse: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftThree: true },
	              _react2.default.createElement(
	                "h1",
	                null,
	                "Finding product/market fit for restaurant revenue management software."
	              )
	            ),
	            _react2.default.createElement("div", {
	              style: {
	                gridColumn: "1 / span 2",
	                height: "6.666px",
	                background: "rgba(255,255,255,0.5)"
	              }
	            }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile overview" },
	              _react2.default.createElement(
	                "p",
	                {
	                  className: "projectSectionMarker",
	                  style: { textAlign: "left" }
	                },
	                "Overview"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: "1.5em" } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "I led product design at Copilot as we strove to find product/market fit. Our proprietary ability to process and distribute data from leading Point of Sale systems gave Copilot the unique ability to provide enterprise-level business insight to independent restaurants."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We dramatically simplified the delivery of actionable insights, focusing on timely push content rather than a power dashboard."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "After several iterations,",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "80% of our customers engaged with Copilot insights every day"
	                ),
	                "."
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { rightOne: true, className: "hideMobile projectDetails" },
	              _react2.default.createElement(_List2.default, { title: "Company", items: ["Copilot"] }),
	              _react2.default.createElement(_List2.default, { title: "Role", items: ["Product designer"] }),
	              _react2.default.createElement(_List2.default, {
	                title: "Core team",
	                items: ["Eli Chait, CEO", "David Amusin, CTO", "Ashley Tyra, Operations", "Hubert Wong, Engineer", "Adam Wagner, Designer"]
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { contain: true, className: _copilotModule2.default.processContainer },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: _copilotModule2.default.processItem, date: "Q4 2012" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Discovery & analysis"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "User research"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Focus on an approach"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _copilotModule2.default.processItem, date: "Q1 2013" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Define the product"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Prioritize features"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Wireframe IA & UX"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Simplify visuals"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Learn from failure"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _copilotModule2.default.processItem, date: "Q2 2013" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Redesign to fit existing workflows"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Simplify more for mobile "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Establish habit"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _copilotModule2.default.processItem, date: "Q3 2013" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Results"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "80% daily engagement"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "74% consider it essential"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white, style: { paddingBottom: 0 } },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "4.5em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Background"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "My involvement"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "As Copilot's only designer, I did ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "many"
	                ),
	                " things, including product marketing, front-end development, and product analysis. Within the scope of this case study I handled:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "arrow-list" },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "User research"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Workflow & product definition"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Wireframing"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Visual design"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Front-end development"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Background"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Audience"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Copilot\u2019s target user is the decision-maker - typically the",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "owner "
	                ),
	                "or ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "general manager"
	                ),
	                " - at an independent restaurant or small restaurant group."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Restaurant decision-makers want to put as many \u201Cbutts in seats\u201D as possible while maintaining smooth operations, high staff morale, and delivering great hospitality."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "They juggle many areas of concern. They\u2019re distracted, often focused on the problem that\u2019s most pressing ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "right now"
	                ),
	                ". There\u2019s little time left to carefully consider decisions affecting the bottom line of their business."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white, style: { paddingBottom: 0 } },
	          _react2.default.createElement("div", {
	            style: {
	              width: "66vw",
	              height: "0.1875em",
	              margin: "0 auto 4.5em",
	              background: _vars.colors.concrete,
	              opacity: 0.66
	            }
	          }),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "3em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Discovery"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Customer insights"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "I spoke with dozens of restaurant owners and general managers to learn how they think about their business, how they spend their day, and what keeps them up at night."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _copilotSketchInterview2.default, alt: "", style: { marginBottom: "3em" } }),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "6em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Takeaways"
	                )
	              ),
	              _react2.default.createElement(
	                "ol",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  { className: "multi-line" },
	                  "Restaurant owners ",
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    "want"
	                  ),
	                  " to put more effort into analyzing business performance data, but aren't able due to distractions and time constraints. It\u2019s like going to the gym - despite good intentions, it's rare."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "multi-line" },
	                  "When users do engage with data, they don't want to dig into the details. They need simple, actionable answers."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "multi-line" },
	                  "Also, they\u2019re skeptical of data that conflicts with their instincts (which is often the case). Copilot must generate trust without overbearing detail."
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "3em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Discovery"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Focusing on an approach"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Copilot existed to facilitate quality decision-making for high-impact activities that our users were neglecting."
	              )
	            )
	          ),
	          _react2.default.createElement("img", {
	            src: _copilotSketchFocus2.default,
	            style: { mixBlendMode: "multiply", marginBottom: "3em" },
	            alt: ""
	          }),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Together, these activities constitute",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Revenue Management"
	                ),
	                " \u2014 the application of disciplined analytics to predict consumer behaviour at the micro-market level and optimize business levers to maximize revenue growth."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement("div", {
	            style: {
	              width: "66vw",
	              height: "0.1875em",
	              margin: "0 auto 4.5em",
	              background: _vars.colors.concrete,
	              opacity: 0.66
	            }
	          }),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Prioritizing functionality"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Beta users helped prioritize features via card sorting \u2014 a research activity in which users categorize features and make tough prioritization decisions.",
	                " "
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { full: true },
	              _react2.default.createElement("img", {
	                style: { gridColumn: "1 / span 4" },
	                src: _copilotCardSort2.default,
	                alt: ""
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.offWhite },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Wireframing IA & UX"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "In the rare cases users engaged with data, they did so on the big screen \u2014 the POS. Card sorting revealed keen interest in powerful data analysis features such as forecasting, benchmarks, and filtering."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Power functionality desired the space and form-factor of the web, so I started there."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _copilotWebWireframe2.default, alt: "" }),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "While testing the wireframes, users were confused by how forecasts were calculated. They were more comfortable using historical benchmarks for forecasting."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { reverse: true, color: _vars.colors.copilotBlue },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Simplifying the UX"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "During visual design I simplified the layout and evolved the forecast model into a flexible benchmark model. Benchmarks were more familiar to users and retained most of the value of a forecast."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _copilotWebMacbook2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Launch & failure"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Once launched, ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "not a single user"
	                ),
	                " logged in. We designed and built Copilot's web product hand-in-hand with a loyal, enthusiastic base of beta customers. And yet, none of them actually wanted to use what their feedback had helped shape."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "But the problem wasn't the feature set.",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "It was the delivery mechanism. "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Recall that our target users have neither the time nor the impulse to log into a web app. They're not even in front of a computer for much of the day. Copilot needed to fit seamlessly into their existing workflow."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.offWhite, style: { paddingBottom: "2em" } },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "3em" } },
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Redesign"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Fitting seamlessly into existing workflows"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The best way to get embedded in our users' chaotic workflows was by being ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "in their pockets."
	                ),
	                " The redesign would be mobile-first."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We wanted Copilot to become an essential habit - akin to the morning cup of coffee or pre-shift staff meeting. To establish this habit, Copilot needed to:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "arrow-list", style: { marginBottom: "1.5em" } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Notify users that a fresh Copilot Daily Report was ready"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Be easily accessible in our users' chaotic environments"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                " I needed to simplify further."
	              )
	            )
	          ),
	          _react2.default.createElement("img", {
	            src: _copilotMobileExplorations2.default,
	            alt: "",
	            style: {
	              maxWidth: "1200px",
	              margin: "auto",
	              marginBottom: "3em"
	            }
	          }),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "In parallel, I continued to discover the compelling power of benchmarking. Comparing current performance to the past was interesting, but it was even ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "more"
	                ),
	                " interesting to compare the daily performance of a single location to that of a ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "group of its peers"
	                ),
	                "."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Another key change the focus on push notifications. At 10am sharp, Copilot would notify users that their daily report was ready to review."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("img", { src: _copilotMobileFnl2.default, alt: "" }),
	        _react2.default.createElement("img", { src: _mobileFinal3Up2.default, alt: "" }),
	        _react2.default.createElement(_VideoWorkaround2.default, {
	          style: {
	            position: "static",
	            opacity: 1,
	            display: "block",
	            width: "100%",
	            objectFit: "fill"
	          },
	          src: _copilotVideoMockup2.default,
	          type: "video/mp4"
	
	        }),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Results"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.copilotBlue } },
	                "Engagement skyrocketed"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "This time, the form factor and focus on notifications worked. Within a month, 80% of users were engaging with the daily report ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "every day"
	                ),
	                "."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Peer group benchmarks proved especially compelling. Customers now considered Copilot an essential part of running their business."
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Copilot;
	}(_react2.default.Component);
	
	exports.default = Copilot;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/pages/copilot.module.styl":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hide--mobile":"src-pages----copilot-module---hide--mobile---23Q6j","show--mobile":"src-pages----copilot-module---show--mobile---u21RL","hide--tablet":"src-pages----copilot-module---hide--tablet---2loPQ","show--tablet":"src-pages----copilot-module---show--tablet---3TKlD","hide--desk":"src-pages----copilot-module---hide--desk---2l0Gi","show--desk":"src-pages----copilot-module---show--desk---1XMuK","hide--huge":"src-pages----copilot-module---hide--huge---3kJ3y","show--huge":"src-pages----copilot-module---show--huge---3aAfc","textSecondary":"src-pages----copilot-module---textSecondary---2vzMd","textSecondaryBold":"src-pages----copilot-module---textSecondaryBold---VUC-B","processContainer":"src-pages----copilot-module---processContainer---dARKn","textBold":"src-pages----copilot-module---textBold---1RAMw","processItem":"src-pages----copilot-module---processItem---3eFPV"};

/***/ }),

/***/ "./src/pages/mobile-final-3-up-3.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-final-3-up-3.41c8d4bc.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-copilot-js-3b010fbfa02fe672a982.js